if (document.querySelector('.js-scroll')) {
  const scrollContainer = document.querySelector('.js-scroll');

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollContainer.classList.add('active');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    // Calculate the distance moved
    const x = e.pageX - scrollContainer.offsetLeft;
    const dx = x - startX;

    // Only prevent default if horizontal scroll is significant
    // This allows vertical scrolling of the page when not dragging horizontally
    if (Math.abs(dx) > 5) {
      e.preventDefault();
    }

    const walk = dx * 1; // scroll speed
    requestAnimationFrame(() => {
      scrollContainer.scrollLeft = scrollLeft - walk;
    });
  });

  // Touch device support
  scrollContainer.addEventListener('touchstart', (e) => {
    isDown = true;
    startX = e.touches[0].pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  });

  scrollContainer.addEventListener('touchend', () => {
    isDown = false;
  });

  scrollContainer.addEventListener('touchmove', (e) => {
    if (!isDown) return;
    // Calculate the distance moved
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const dx = x - startX;

    // Only prevent default if horizontal scroll is significant
    // This allows vertical scrolling of the page when not dragging horizontally
    if (Math.abs(dx) > 5) {
      e.preventDefault();
    }

    const walk = dx * 1.2; // Increased speed for iOS
    requestAnimationFrame(() => {
      scrollContainer.scrollLeft = scrollLeft - walk;
    });
  });
}
